"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBanner = void 0;
var useBanner_hook_1 = require("./useBanner.hook");
Object.defineProperty(exports, "useBanner", { enumerable: true, get: function () { return useBanner_hook_1.useBanner; } });
//# sourceMappingURL=index.js.map